import { createFileRoute } from '@tanstack/react-router';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';
import LandingPage from '../pages/LandingPage/LandingPage';

export const Route = createFileRoute('/')({
  component: Index
});

function Index() {
  return (
    <PageWrapper title="" description="Trades, rights and decisions in the Murray-Darling Basin">
      <LandingPage />
    </PageWrapper>
  );
}
